import { PickupsGroupModel, PickupsResponseContentModel } from "../../app/data/pickup/models";
import { PickupStatus } from "../../app/data/pickup/status";

export const getPickupById = (pickups, id) => (
  pickups.reduce((result, item) => {
    if (result) return result
    if (item.pickups?.length > 0) {
      return getPickupById(item.pickups, id)
    }
    return item.pickup.pickupId === id ? item : null
  }, null)
);

export const getPickupsByIds = (pickups, ids) => (
  pickups.reduce((result, item) => {    
    if (item.pickups?.length > 0) {
      return [...result, ...getPickupsByIds(item.pickups, ids)];
    }
    return ids.find(id => id === item.pickup.pickupId) ? [...result, item] : result
  }, [])
);

export const getPickupGroupStatus = (items: PickupsResponseContentModel[]) => {
  if (items.find(item => (item.status === PickupStatus.COMPLETED))) return PickupStatus.COMPLETED;

  if (items.find(item => item.status === PickupStatus.UNASSIGNED)) return PickupStatus.UNASSIGNED;

  if (items.find(item => item.status === PickupStatus.ASSIGNED)) return PickupStatus.ASSIGNED;

  return PickupStatus.CANCELED;
}

export const isGroup = (item: PickupsResponseContentModel | PickupsGroupModel ): item is PickupsGroupModel => ("pickups" in item && !!item.pickups);

export const isSubPickup = (item: PickupsResponseContentModel | PickupsGroupModel): item is PickupsResponseContentModel => !isGroup(item) && !item.pickup.single;

export const convertToSubPickup = (item: PickupsResponseContentModel) => ({ ...item, pickup: { ...item.pickup, single: false }});
